<app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

<div class="container-body">
    <a class="back-link" routerLink="/developer/batch-config">
        <mat-icon aria-hidden="false" aria-label="Plus">arrow_back</mat-icon> Configuração Batch
    </a>
    <h1>Configurar Batch</h1>
    <app-loading-progress-bar *ngIf="isFirstLoading"></app-loading-progress-bar>
    <div class="white-body">
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome do projeto</mat-label>
                        <input matInput type="text" formControlName="projectName">
                        <mat-error *ngIf="model.get('projectName').invalid">Informe o nome</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <mat-form-field>
                        <mat-label>Data Inicial</mat-label>
                        <input matInput type="text" inputmode="datetime-local" placeholder="Choose a date & time"
                            formControlName="datetimeInit" [mask]="masks.datetime">
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Trigger</mat-label>
                        <input matInput type="number" formControlName="timeCourseHour">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <span>
                    Inscrição
                    <mat-slide-toggle formControlName="subscribed"></mat-slide-toggle>
                </span>
                <span>
                    Projeto crítico
                    <mat-slide-toggle formControlName="isCritical"></mat-slide-toggle>
                </span>
            </div>
            <div class="row">
                <details>
                    <summary>Inscritos</summary>
                    <ul>
                        <li *ngFor="let email of model.get('subscriptions').value">{{email}}</li>
                    </ul>
                </details>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <button mat-button type="submit" class="btn-primary btn-block">
                        <span *ngIf="isLoading == false">Salvar</span>
                        <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
                    </button>
                </div>
                <div class="col-md-2">
                    <a mat-stroked-button type="button" routerLink="/developer/batch-config"
                        class="btn-secundary btn-block">
                        Cancelar
                    </a>
                </div>
            </div>
        </form>
    </div>
</div>